import { render, staticRenderFns } from "./SectionBuilders.vue?vue&type=template&id=5b9b4b0e&"
import script from "./SectionBuilders.vue?vue&type=script&lang=js&"
export * from "./SectionBuilders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports